/**
 * Quote Generator - genera cotizaciones en PDF a partir del carrito actual.
 * Requiere: sections/quote-generator.liquid (define window.quoteGeneratorSettings)
 *
 * Carga jsPDF + jsPDF-AutoTable desde CDN solo cuando se necesitan (al generar el PDF),
 * para no afectar el rendimiento del resto del sitio.
 */
(function () {
  var settings = window.quoteGeneratorSettings || {};
  var state = { cart: null };

  var els = {};

  function cacheEls() {
    els.tableBody = document.getElementById('qg-table-body');
    els.subtotal = document.getElementById('qg-subtotal');
    els.total = document.getElementById('qg-total');
    els.generateBtn = document.getElementById('qg-generate-pdf');
    els.refreshBtn = document.getElementById('qg-refresh');
    els.status = document.getElementById('qg-status');
    els.passwordGate = document.getElementById('qg-password-gate');
    els.passwordInput = document.getElementById('qg-password-input');
    els.passwordSubmit = document.getElementById('qg-password-submit');
    els.passwordError = document.getElementById('qg-password-error');
    els.mainPanel = document.getElementById('quote-generator');
  }

  function unlock() {
    // No se guarda en localStorage a propósito: la contraseña se debe pedir
    // de nuevo cada vez que se recarga la página, no solo la primera vez.
    if (els.passwordGate) els.passwordGate.style.display = 'none';
    if (els.mainPanel) els.mainPanel.style.display = '';
    // Avisa a otras secciones en la misma página (ej. el buscador de productos)
    // que también deben mostrarse, sin necesidad de recargar.
    document.dispatchEvent(new CustomEvent('qg:unlocked'));
  }

  function checkPassword() {
    var entered = els.passwordInput ? els.passwordInput.value : '';
    if (settings.accessPassword && entered === settings.accessPassword) {
      unlock();
      startApp();
    } else {
      if (els.passwordError) els.passwordError.style.display = 'block';
    }
  }

  function bindPasswordGate() {
    if (!els.passwordGate) return;

    if (els.passwordSubmit) els.passwordSubmit.addEventListener('click', checkPassword);
    if (els.passwordInput) {
      els.passwordInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') checkPassword();
      });
    }
  }

  function formatMoney(cents) {
    // Usa el money_format de la tienda si está disponible; si no, un fallback simple.
    var value = (cents / 100).toFixed(2);
    if (settings.moneyFormat && settings.moneyFormat.indexOf('{{amount}}') > -1) {
      return settings.moneyFormat.replace('{{amount}}', value);
    }
    return (settings.currency || '$') + value;
  }

  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        state.cart = cart;
        renderPreview(cart);
        return cart;
      })
      .catch(function (err) {
        setStatus('No se pudo leer el carrito.');
        console.error('[quote-generator]', err);
      });
  }

  function renderPreview(cart) {
    if (!els.tableBody) return;

    if (!cart.items.length) {
      els.tableBody.innerHTML = '<tr><td colspan="6" class="qg-empty">Tu carrito está vacío.</td></tr>';
      els.subtotal.textContent = formatMoney(0);
      els.total.textContent = formatMoney(0);
      els.generateBtn.disabled = true;
      return;
    }

    var rows = cart.items.map(function (item) {
      var title = item.product_title + (item.variant_title ? ' - ' + item.variant_title : '');
      return (
        '<tr>' +
          '<td>' + escapeHtml(title) + '</td>' +
          '<td>' + escapeHtml(item.sku || '-') + '</td>' +
          '<td>' + item.quantity + '</td>' +
          '<td>' + formatMoney(item.price) + '</td>' +
          '<td>' + formatMoney(item.line_price) + '</td>' +
          '<td><button type="button" class="qg-remove-btn" data-key="' + item.key + '" title="Quitar de la cotización">Quitar</button></td>' +
        '</tr>'
      );
    });

    els.tableBody.innerHTML = rows.join('');
    els.subtotal.textContent = formatMoney(cart.total_price);
    els.total.textContent = formatMoney(cart.total_price);
    els.generateBtn.disabled = false;
  }

  // Quita un producto del carrito (cantidad 0) y refresca la vista previa.
  function removeItem(key, btn) {
    if (!key) return;
    if (btn) { btn.disabled = true; btn.textContent = '...'; }

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        state.cart = cart;
        renderPreview(cart);
        setStatus('Producto quitado de la cotización.');
      })
      .catch(function (err) {
        console.error('[quote-generator] remove item', err);
        setStatus('No se pudo quitar el producto.');
        if (btn) { btn.disabled = false; btn.textContent = 'Quitar'; }
      });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  function setStatus(msg) {
    if (els.status) els.status.textContent = msg;
  }

  // --- Carga diferida de jsPDF ---
  var LIBS_URL = [
    'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js'
  ];
  var libsLoaded = false;

  function loadLibs() {
    if (libsLoaded) return Promise.resolve();
    return LIBS_URL.reduce(function (chain, src) {
      return chain.then(function () { return loadScript(src); });
    }, Promise.resolve()).then(function () {
      libsLoaded = true;
    });
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function getFormData() {
    return {
      customerName: val('qg-customer-name'),
      customerCompany: val('qg-customer-company'),
      customerEmail: val('qg-customer-email'),
      customerPhone: val('qg-customer-phone'),
      vendorName: val('qg-vendor-name'),
      validity: val('qg-validity') || 15,
      notes: val('qg-notes')
    };
  }

  function val(id) {
    var el = document.getElementById(id);
    return el ? el.value.trim() : '';
  }

  // Convierte la imagen de un producto (URL del CDN de Shopify) a un data URL en base64,
  // que es lo único que jsPDF puede insertar de forma confiable. Si la imagen no carga
  // (por CORS o cualquier otro motivo), resuelve null y esa fila simplemente no lleva foto.
  function loadImageAsDataUrl(url) {
    return new Promise(function (resolve) {
      if (!url) { resolve(null); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL('image/jpeg', 0.85));
        } catch (e) {
          resolve(null);
        }
      };
      img.onerror = function () { resolve(null); };
      img.src = url;
    });
  }

  // Precarga las imágenes de todos los productos del carrito antes de dibujar el PDF,
  // para no tener que esperar imagen por imagen mientras se genera.
  function preloadItemImages(cart) {
    if (!settings.showItemImages) return Promise.resolve({});
    return Promise.all(
      cart.items.map(function (item) { return loadImageAsDataUrl(item.image); })
    ).then(function (dataUrls) {
      var map = {};
      cart.items.forEach(function (item, i) { map[item.key] = dataUrls[i]; });
      return map;
    });
  }

  // Quita las etiquetas HTML de la descripción del producto y colapsa espacios,
  // para que quede como texto plano legible dentro del PDF.
  function stripHtml(html) {
    if (!html) return '';
    var div = document.createElement('div');
    div.innerHTML = html;
    var text = div.textContent || div.innerText || '';
    return text.replace(/\s+/g, ' ').trim();
  }

  var productDescCache = {}; // handle -> descripción en texto plano (evita pedirla dos veces)

  function loadProductDescription(handle) {
    if (!handle) return Promise.resolve('');
    if (productDescCache[handle] !== undefined) return Promise.resolve(productDescCache[handle]);

    return fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        var text = stripHtml(product.description);
        productDescCache[handle] = text;
        return text;
      })
      .catch(function () {
        productDescCache[handle] = '';
        return '';
      });
  }

  // Precarga la descripción de cada producto distinto del carrito (una sola vez por producto,
  // aunque tenga varias variantes en el carrito) antes de dibujar el PDF.
  function preloadItemDescriptions(cart) {
    if (!settings.showItemDescriptions) return Promise.resolve({});

    var uniqueHandles = [];
    cart.items.forEach(function (item) {
      if (item.handle && uniqueHandles.indexOf(item.handle) === -1) uniqueHandles.push(item.handle);
    });

    return Promise.all(uniqueHandles.map(loadProductDescription)).then(function () {
      var map = {};
      cart.items.forEach(function (item) {
        map[item.key] = productDescCache[item.handle] || '';
      });
      return map;
    });
  }

  // Construye las líneas de descripción de cada producto: variante + propiedades
  // de línea (line item properties), igual que en tu factura (título + bullets debajo).
  function getItemDescriptionLines(item) {
    var lines = [];
    if (item.variant_title && item.variant_title !== 'Default Title') {
      lines.push(item.variant_title);
    }
    if (item.properties) {
      Object.keys(item.properties).forEach(function (key) {
        var value = item.properties[key];
        if (!value || key.indexOf('_') === 0) return; // ignora propiedades ocultas (empiezan con _)
        lines.push(key + ': ' + value);
      });
    }
    return lines;
  }

  function generatePdf() {
    if (!state.cart || !state.cart.items.length) return;

    setStatus('Generando PDF...');
    els.generateBtn.disabled = true;

    loadLibs().then(function () {
      return Promise.all([preloadItemImages(state.cart), preloadItemDescriptions(state.cart)]);
    }).then(function (preloaded) {
      var imageMap = preloaded[0];
      var descMap = preloaded[1];
      var jsPDF = window.jspdf.jsPDF;
      var doc = new jsPDF({ unit: 'pt', format: 'a4' });
      var form = getFormData();
      var pageWidth = doc.internal.pageSize.getWidth();
      var pageHeight = doc.internal.pageSize.getHeight();
      var margin = 40;
      var bottomLimit = pageHeight - 60;
      var quoteNumber = 'COT-' + Date.now().toString().slice(-8);
      var today = new Date();
      var validUntil = new Date(today.getTime() + (parseInt(form.validity, 10) || 15) * 86400000);
      var imgSize = 32; // lado del cuadro de foto por producto, en pt
      var imgGap = 10;
      var showImages = !!settings.showItemImages;

      // Columnas de la tabla (igual que en la factura: Descripción / Rate / Qty / Amount)
      var col = {
        imageX: margin,
        descX: showImages ? margin + imgSize + imgGap : margin,
        descWidth: pageWidth - margin * 2 - 190 - (showImages ? imgSize + imgGap : 0),
        rateX: pageWidth - margin - 150,
        qtyX: pageWidth - margin - 80,
        amountX: pageWidth - margin
      };

      function drawHeader() {
        var y = margin;

        // Logo
        if (settings.logoUrl) {
          try { doc.addImage(settings.logoUrl, 'JPEG', margin, y, 110, 48); } catch (e) { /* CORS: seguimos sin logo */ }
        }

        // Datos de la empresa, a la derecha del logo
        var infoX = settings.logoUrl ? margin + 130 : margin;
        doc.setFont(undefined, 'bold');
        doc.setFontSize(13);
        doc.setTextColor('#1a1a1a');
        doc.text(settings.shopName || '', infoX, y + 10);

        doc.setFont(undefined, 'normal');
        doc.setFontSize(8.5);
        doc.setTextColor('#555555');
        var infoLines = [settings.shopAddress, settings.shopCity, settings.shopPhone, settings.shopEmail].filter(Boolean);
        infoLines.forEach(function (line, i) { doc.text(line, infoX, y + 26 + i * 11); });

        // Título + No. + fecha + total, a la derecha
        doc.setFont(undefined, 'bold');
        doc.setFontSize(13);
        doc.setTextColor('#1a1a1a');
        doc.text((settings.pdfTitle || 'COTIZACIÓN').toUpperCase(), pageWidth - margin, y + 10, { align: 'right' });

        doc.setFont(undefined, 'normal');
        doc.setFontSize(8.5);
        doc.setTextColor('#555555');
        doc.text(quoteNumber, pageWidth - margin, y + 24, { align: 'right' });
        doc.text('FECHA', pageWidth - margin, y + 40, { align: 'right' });
        doc.setTextColor('#1a1a1a');
        doc.text(today.toLocaleDateString(), pageWidth - margin, y + 52, { align: 'right' });
        doc.setTextColor('#555555');
        doc.text('TOTAL', pageWidth - margin, y + 68, { align: 'right' });
        doc.setFont(undefined, 'bold');
        doc.setTextColor('#1a1a1a');
        doc.text(formatMoney(state.cart.total_price), pageWidth - margin, y + 80, { align: 'right' });

        y += 100;
        doc.setDrawColor('#cccccc');
        doc.line(margin, y, pageWidth - margin, y);
        y += 20;

        // Cliente ("TO")
        doc.setFont(undefined, 'normal');
        doc.setFontSize(8);
        doc.setTextColor('#888888');
        doc.text('TO', margin, y);
        y += 14;
        doc.setFont(undefined, 'bold');
        doc.setFontSize(11);
        doc.setTextColor('#1a1a1a');
        doc.text(form.customerCompany || form.customerName || 'Cliente', margin, y);
        y += 14;
        doc.setFont(undefined, 'normal');
        doc.setFontSize(9);
        doc.setTextColor('#555555');
        var custExtra = [
          form.customerCompany ? form.customerName : null,
          form.customerEmail,
          form.customerPhone
        ].filter(Boolean);
        custExtra.forEach(function (line) { doc.text(line, margin, y); y += 12; });

        y += 14;

        // Encabezado de tabla
        doc.setFontSize(8);
        doc.setTextColor('#888888');
        doc.text('DESCRIPTION', col.descX, y);
        doc.text('RATE', col.rateX, y, { align: 'right' });
        doc.text('QTY', col.qtyX, y, { align: 'right' });
        doc.text('AMOUNT', col.amountX, y, { align: 'right' });
        y += 6;
        doc.setDrawColor('#1a1a1a');
        doc.line(margin, y, pageWidth - margin, y);
        y += 16;

        return y;
      }

      var y = drawHeader();

      state.cart.items.forEach(function (item) {
        var descLines = getItemDescriptionLines(item);

        var productDesc = descMap[item.key] || '';
        var wrappedProductDesc = productDesc ? doc.splitTextToSize(productDesc, col.descWidth) : [];

        var wrappedTitle = doc.splitTextToSize(item.product_title, col.descWidth);
        var textHeight = wrappedTitle.length * 12 + descLines.length * 11 + wrappedProductDesc.length * 10 + 18;
        var blockHeight = showImages ? Math.max(textHeight, imgSize + 18) : textHeight;

        if (y + blockHeight > bottomLimit) {
          doc.addPage();
          y = drawHeader();
        }

        if (showImages) {
          var dataUrl = imageMap[item.key];
          if (dataUrl) {
            try { doc.addImage(dataUrl, 'JPEG', col.imageX, y - 9, imgSize, imgSize); } catch (e) { /* seguimos sin esa foto */ }
          } else {
            doc.setDrawColor('#dddddd');
            doc.rect(col.imageX, y - 9, imgSize, imgSize);
          }
        }

        doc.setFont(undefined, 'bold');
        doc.setFontSize(9.5);
        doc.setTextColor('#1a1a1a');
        doc.text(wrappedTitle, col.descX, y);

        doc.setFont(undefined, 'normal');
        doc.setFontSize(9);
        doc.text(formatMoney(item.price), col.rateX, y, { align: 'right' });
        doc.text(String(item.quantity), col.qtyX, y, { align: 'right' });
        doc.text(formatMoney(item.line_price), col.amountX, y, { align: 'right' });

        var lineY = y + wrappedTitle.length * 12;

        if (descLines.length) {
          doc.setFont(undefined, 'normal');
          doc.setFontSize(8.5);
          doc.setTextColor('#666666');
          descLines.forEach(function (line) {
            doc.text(line, col.descX, lineY);
            lineY += 11;
          });
        }

        if (wrappedProductDesc.length) {
          doc.setFont(undefined, 'italic');
          doc.setFontSize(8);
          doc.setTextColor('#777777');
          doc.text(wrappedProductDesc, col.descX, lineY);
          lineY += wrappedProductDesc.length * 10;
          doc.setFont(undefined, 'normal');
        }

        if (showImages) {
          var imageBottom = (y - 9) + imgSize; // borde inferior de la foto de este producto
          if (imageBottom > lineY) lineY = imageBottom;
        }

        y = lineY + 8;
        doc.setDrawColor('#dddddd');
        doc.setLineDashPattern([1, 1], 0);
        doc.line(margin, y, pageWidth - margin, y);
        doc.setLineDashPattern([], 0);
        y += 18;
      });

      if (y + 40 > bottomLimit) {
        doc.addPage();
        y = drawHeader();
      }

      doc.setFont(undefined, 'normal');
      doc.setFontSize(9);
      doc.setTextColor('#555555');
      doc.text('TOTAL', col.rateX, y, { align: 'right' });
      doc.setFont(undefined, 'bold');
      doc.setFontSize(12);
      doc.setTextColor('#1a1a1a');
      doc.text(formatMoney(state.cart.total_price), col.amountX, y, { align: 'right' });
      y += 30;

      // --- Notas ---
      if (form.notes) {
        doc.setFont(undefined, 'bold');
        doc.setFontSize(9);
        doc.setTextColor('#333333');
        doc.text('Notas:', margin, y);
        doc.setFont(undefined, 'normal');
        var notesLines = doc.splitTextToSize(form.notes, pageWidth - margin * 2);
        doc.text(notesLines, margin, y + 14);
        y += 14 + (notesLines.length * 12) + 10;
      }

      // --- Vendedor / validez ---
      doc.setFontSize(8.5);
      doc.setTextColor('#333333');
      if (form.vendorName) { doc.text('Atendido por: ' + form.vendorName, margin, y); y += 12; }
      doc.text('Cotización válida hasta: ' + validUntil.toLocaleDateString(), margin, y);

      // --- Pie de página ---
      if (settings.footerText) {
        doc.setFont(undefined, 'normal');
        doc.setFontSize(8);
        doc.setTextColor('#888888');
        var footerLines = doc.splitTextToSize(settings.footerText, pageWidth - margin * 2);
        doc.text(footerLines, margin, pageHeight - 40);
      }

      var fileName = 'cotizacion-' + quoteNumber + '.pdf';
      doc.save(fileName);
      setStatus('PDF generado: ' + fileName);

      if (settings.sendEmailOnGenerate && settings.emailEndpointUrl) {
        var pdfBase64 = doc.output('datauristring').split(',')[1];
        var toEmails = [settings.shopEmail, form.customerEmail].filter(Boolean);

        sendQuoteEmail({
          pdfBase64: pdfBase64,
          fileName: fileName,
          toEmails: toEmails,
          subject: 'Cotización ' + quoteNumber + ' - ' + (settings.shopName || ''),
          quoteNumber: quoteNumber,
          customerName: form.customerName,
          vendorName: form.vendorName
        });
      } else {
        els.generateBtn.disabled = false;
      }
    }).catch(function (err) {
      console.error('[quote-generator]', err);
      setStatus('Error al generar el PDF.');
      els.generateBtn.disabled = false;
    });
  }

  function sendQuoteEmail(payload) {
    setStatus('PDF generado. Enviando por correo...');

    // Content-Type "text/plain" evita el preflight CORS que Apps Script no maneja bien.
    fetch(settings.emailEndpointUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        // Leemos como texto primero: si la respuesta no es JSON válido (por ejemplo, una
        // página de error o de login de Google), queremos poder mostrar por qué falló
        // en vez de solo decir "no se pudo enviar".
        return res.text().then(function (text) {
          var data;
          try {
            data = JSON.parse(text);
          } catch (e) {
            throw new Error('respuesta no válida del servidor (código ' + res.status + '): ' + text.slice(0, 150));
          }
          return data;
        });
      })
      .then(function (data) {
        if (data && data.ok) {
          setStatus('PDF generado y enviado a: ' + payload.toEmails.join(', '));
        } else {
          setStatus('PDF generado, pero el correo falló: ' + (data && data.error ? data.error : 'error desconocido'));
        }
      })
      .catch(function (err) {
        console.error('[quote-generator] email', err);
        setStatus('PDF generado, pero no se pudo enviar el correo: ' + err.message);
      })
      .finally(function () {
        els.generateBtn.disabled = false;
      });
  }

  // --- Mantener la vista previa sincronizada con el carrito ---
  function bindCartSync() {
    // 1) Botón manual de actualizar
    if (els.refreshBtn) els.refreshBtn.addEventListener('click', fetchCart);

    // 2) Eventos comunes que disparan muchos temas (Dawn y derivados) al modificar el carrito
    document.addEventListener('cart:updated', fetchCart);
    document.addEventListener('cart:refresh', fetchCart);
    document.body.addEventListener('cart:updated', fetchCart);

    // 3) Intercepta cualquier fetch a /cart/add.js, /cart/change.js, /cart/update.js
    //    para refrescar automáticamente sin depender de eventos propios del tema.
    var originalFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] instanceof Request ? arguments[0].url : arguments[0];
      var result = originalFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        result.then(function () { fetchCart(); });
      }
      return result;
    };

    // 4) Respaldo: revisa el carrito cada pocos segundos mientras el panel está visible
    setInterval(fetchCart, 5000);
  }

  // Botón "Quitar" de cada fila (delegado, porque las filas se regeneran en cada render).
  function bindRemoveButtons() {
    if (!els.tableBody) return;
    els.tableBody.addEventListener('click', function (e) {
      var btn = e.target.closest('.qg-remove-btn');
      if (!btn) return;
      removeItem(btn.dataset.key, btn);
    });
  }

  function startApp() {
    if (!els.tableBody) return; // la sección no está en esta página
    bindCartSync();
    bindRemoveButtons();
    fetchCart();
    if (els.generateBtn) els.generateBtn.addEventListener('click', generatePdf);
  }

  function init() {
    cacheEls();
    if (!els.tableBody) return; // la sección no está en esta página

    if (els.passwordGate) {
      bindPasswordGate();
    } else {
      // No hay pantalla de contraseña en esta instalación: arrancar directo.
      startApp();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();